import {MediaSourceType} from '../media-source';

export class UploadMediaRequest {
  mediaSourceId: number = 0;
  name: string = '';
  filename: string = '';
  mediaSourceType: MediaSourceType = MediaSourceType.Unknown;
  data: string = '';
  category: string = '';
  description: string = '';
}
